import { arrayConverter, renderChildren, filterSpace, } from "./helpers";
export default (function (_a) {
    var filterList = _a.filterList;
    var componentsToRender = filterList
        .filter(function (item) { return (item && !item.selector) || item === filterSpace; })
        .map(function (item) { return item && item.component; });
    // the items are placed in a multidimensional array, essentially a parent array of child arrays
    // colNumber tells us how many child arrays there will be in a column, to render up to four columns
    // the child arrays are rendered as flex columns
    // eg if there are 4 items, 4/4 = 1, so each column will have one entry
    // if there are 3, 3/4 = 0.75 and the ceiling of that is 1, so each column will have 1 entry and there will be only 3 columns
    // if there are 5, 5/4 = 1.25 (ceil 2) = 2 per column. We will run out of items before rendering the 4th column
    // so two columns of 2, and one column of one
    var colNumber = Math.ceil(componentsToRender.length / 4);
    // created that multidimensional array based on column size we just derived
    var reduced = arrayConverter(componentsToRender, colNumber);
    return renderChildren(reduced, 4, false);
});
//# sourceMappingURL=FilterChild.js.map